export default __webpack_public_path__ + "static/lysicrates-torn-parper-tablet-mobile-bottom-menu-64d0d95ddbd63d9d78778f02b360717f.png";